<template>
  <div class="wrapper">
    <div class="filter white_box">
      <!-- 第一行：搜索框、日期选择器和按钮 -->
      <div class="filter-row">
        <!-- 搜索框 -->
        <el-input
          class="custom-es"
          size="medium"
          placeholder="请输入员工姓名/证件号码/手机号码"
          v-model="input"
          clearable
        ></el-input>
        
        <!-- 合同开始日期 -->
        <div class="date-group">
          <span class="date-label">合同开始日期：</span>
          <el-date-picker
            v-model="contractStartDateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            value-format="yyyy-MM-dd"
            end-placeholder="结束日期"
            size="medium"
          >
          </el-date-picker>
        </div>
        
        <!-- 合同结束日期 -->
        <div class="date-group">
          <span class="date-label">合同结束日期：</span>
          <el-date-picker
            v-model="contractEndDateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            value-format="yyyy-MM-dd"
            end-placeholder="结束日期"
            size="medium"
          >
          </el-date-picker>
        </div>
        
        <!-- 按钮组：查询、重置、导出 -->
        <div class="button-group">
          <button-a color="#f26828" class="query" @click.native="query()"
            >查询</button-a
          >
          <button-a color="#08a752" @click.native="reset()">重置</button-a>
          <button-a
            class="export"
            color="#ffffff"
            bgcolor="#85cf96"
            @click.native="dialog()"
            >导出</button-a
          >
        </div>
      </div>
      
      <!-- 第二行：筛选标签 -->
      <div class="filter-row">
        <!-- 合同类型 -->
        <div class="filter-group">
          <p class="font_14_black">合同类型:</p>
          <div class="filter-tags">
            <filter-tag
              :class="{ active: contractType[0] }"
              @click.native="change('contractType', 0)"
              name="劳动合同"
            />
            <filter-tag
              :class="{ active: contractType[1] }"
              @click.native="change('contractType', 1)"
              name="实习协议"
            />
            <filter-tag
              :class="{ active: contractType[2] }"
              @click.native="change('contractType', 2)"
              name="返聘协议"
            />
          </div>
        </div>

        <!-- 合同状态 -->
        <div class="filter-group">
          <p class="font_14_black">合同状态:</p>
          <div class="filter-tags">
            <filter-tag
              :class="{ active: contractStatus[0] }"
              @click.native="change('contractStatus', 0)"
              name="生效中"
            />
            <filter-tag
              :class="{ active: contractStatus[1] }"
              @click.native="change('contractStatus', 1)"
              name="已到期"
            />
          </div>
        </div>

        <!-- 签约类型 -->
        <div class="filter-group">
          <p class="font_14_black">签约类型:</p>
          <div class="filter-tags">
            <filter-tag
              :class="{ active: qianyueType[0] }"
              @click.native="change('qianyueType', 0)"
              name="新签"
            />
            <filter-tag
              :class="{ active: qianyueType[1] }"
              @click.native="change('qianyueType', 1)"
              name="续签"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="result white_box">
      <!-- 表格
        ref="multipleTable" 引用名
        :data="tableData" 绑定数据
        tooltip-effect 鼠标hover提示效果
        :header-row-style 表头样式
        :header-cell-style 表头单元格样式
        :row-style="rowStyle" 行样式
      -->
      <div v-loading="loading" element-loading-text="加载中..." class="table-wrapper">
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        :header-row-style="{
          height: translateWidth(68) + 'px',
          fongSize: '14px',
          color: '#000',
          backgroundColor: '#fafbff'
        }"
        :header-cell-style="{ backgroundColor: 'transparent' }"
        :row-style="{
          height: translateWidth(60) + 'px',
          backgroundColor: '#fff'
        }"
        style="
          width: 100%;
          font-size: 14px;
          color: #707070;
          border: 1px solid #e5e5e5;
          border-radius: 6px;
        "
        @row-click="handleRowClick"
        @row-dblclick="handleRowDblclick"
        @row-mousedown="handleRowMousedown"
        @row-mousemove="handleRowMousemove"
        @row-mouseup="handleRowMouseup"
      >
        <!-- 占位列 -->
        <el-table-column :width="35 | translateWidth"></el-table-column>
        <!-- 多选框 -->

        <el-table-column
          type="index"
          label="序号"
          :width="70 | translateWidth"
        ></el-table-column>
        <el-table-column
          prop="customerName"
          label="所属企业"
          show-overflow-tooltip
          :width="200 | translateWidth"
        ></el-table-column>
        <el-table-column
          prop="employeeName"
          label="员工姓名"
          show-overflow-tooltip
          :width="110 | translateWidth"
        ></el-table-column>
        <el-table-column
          prop="idCard"
          label="证件号码"
          show-overflow-tooltip
          :width="180 | translateWidth"
        ></el-table-column>
         <el-table-column
          prop="phone"
          label="手机号码"
          show-overflow-tooltip
          width="122"
        ></el-table-column>
        <el-table-column
          prop="contractCode"
          label="合同编号"
          show-overflow-tooltip
          width="122"
        ></el-table-column>
        <el-table-column
          prop="contractType"
          label="合同类型"
          show-overflow-tooltip
          :width="110 | translateWidth"
        ></el-table-column>
        <el-table-column
          prop="signType"
          label="签约类型"
          show-overflow-tooltip
          :width="110 | translateWidth"
        ></el-table-column>
        <el-table-column
          label="合同开始时间"
          show-overflow-tooltip
          :width="150 | translateWidth"
        >
          <template slot-scope="scope">{{
            date(scope.row.beginTime)
          }}</template>
        </el-table-column>
        <el-table-column
          label="合同结束时间"
          show-overflow-tooltip
          :width="150 | translateWidth"
        >
          <template slot-scope="scope">{{ date(scope.row.endTime) }}</template>
        </el-table-column>
        <el-table-column
          label="状态"
          show-overflow-tooltip
          :width="100 | translateWidth"
        >
          <template slot-scope="scope">{{ getStatus(scope.row) }}</template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <span class="font_14_orange pointer view" @click="view(scope.row)"
              >查看</span
            >
          </template>
        </el-table-column>
      </el-table>
      </div>
      <!-- 分页 -->
      <el-pagination
        ref="pagination"
        :current-page="page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, prev, pager, next, sizes, jumper, ->, slot"
        :total="total"
      ></el-pagination>
    </div>

    <el-dialog title :visible.sync="mask" width="40%" center>
      <h3 class="export-title font_16_black">员工合同列表信息导出</h3>
      <!-- <div class="export-item">
        <p class="export-item-name font_14_black">所属组织</p>
        <el-select
          class="custom-os"
          v-model="selectedValue2"
          multiple
          filterable
          clearable
          default-first-option
          size="medium"
          placeholder="请选择组织或输入关键字搜索"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div> -->
      <div class="switch">
        <!-- <div class="switch-group">
          <div class="switch-title">合同类型</div>
          <div class="switch-item">
            <el-switch
              v-model="switchGroup11['劳动合同']"
              @change="changeSwitchGroup11"
              :disabled="disabled === '劳动合同'"
            ></el-switch>
            <span class="item-name font_14_darkgray">劳动合同</span>
          </div>
          <div class="switch-item">
            <el-switch
              v-model="switchGroup11['实习协议']"
              @change="changeSwitchGroup11"
              :disabled="disabled === '实习协议'"
            ></el-switch>
            <span class="item-name font_14_darkgray">实习协议</span>
          </div>
          <div class="switch-item">
            <el-switch
              v-model="switchGroup11['返聘协议']"
              @change="changeSwitchGroup11"
              :disabled="disabled === '返聘协议'"
            ></el-switch>
            <span class="item-name font_14_darkgray">返聘协议</span>
          </div>
          <div class="switch-item"></div>
        </div>

        <div class="switch-group">
          <div class="switch-title">签约类型</div>
          <div class="switch-item">
            <el-switch
              v-model="switchGroup12['新签']"
              @change="changeSwitchGroup12"
              :disabled="disabled === '新签'"
            ></el-switch>
            <span class="item-name font_14_darkgray">新签</span>
          </div>
          <div class="switch-item">
            <el-switch
              v-model="switchGroup12['续签']"
              @change="changeSwitchGroup12"
              :disabled="disabled === '续签'"
            ></el-switch>
            <span class="item-name font_14_darkgray">续签</span>
          </div>
          <div class="switch-item"></div>
        </div> -->
        <!-- 开关组 -->
        <!-- <div class="switch-group">
        <div class="switch-title">导出字段</div>-->
        <!-- 开关项
            disabled 禁止修改，可用于必选
        -->
        <!-- <div class="switch-item">
            <el-switch v-model="switchGroup2['所属组织']" disabled></el-switch>
            <span class="item-name font_14_darkgray">所属组织</span>
          </div>
          <div class="switch-item">
            <el-switch v-model="switchGroup2['员工姓名']" disabled></el-switch>
            <span class="item-name font_14_darkgray">员工姓名</span>
          </div>
          <div class="switch-item">
            <el-switch v-model="switchGroup2['证件号码']" disabled></el-switch>
            <span class="item-name font_14_darkgray">证件号码</span>
          </div>
          <div class="switch-item">
            <el-switch v-model="switchGroup2['合同编号']" disabled></el-switch>
            <span class="item-name font_14_darkgray">合同编号</span>
          </div>
          <div class="switch-item">
            <el-switch v-model="switchGroup2['合同类型']"></el-switch>
            <span class="item-name font_14_darkgray">合同类型</span>
          </div>
          <div class="switch-item">
            <el-switch v-model="switchGroup2['签约类型']"></el-switch>
            <span class="item-name font_14_darkgray">签约类型</span>
          </div>
          <div class="switch-item">
            <el-switch v-model="switchGroup2['合同开始时间']"></el-switch>
            <span class="item-name font_14_darkgray">合同开始时间</span>
          </div>
          <div class="switch-item">
            <el-switch v-model="switchGroup2['合同结束时间']"></el-switch>
            <span class="item-name font_14_darkgray">合同结束时间</span>
          </div>
          <div class="switch-item"></div>
        </div>
        -->
      </div>
      <div class="transfer">
        <el-transfer
          style="text-align: left; display: inline-block"
          v-model="export_value"
          :data="export_data"
          filterable
          :render-content="renderFunc"
          :titles="['请选择导出字段', '已选择字段']"
          :button-texts="['到左侧', '到右侧']"
        >
          <!-- <el-button class="transfer-footer" slot="left-footer" size="small">操作</el-button> -->
          <!-- <el-button class="transfer-footer" slot="right-footer" size="small">操作</el-button> -->
        </el-transfer>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="export_btn">
          <button-a
            padding="10px 128px"
            color="#fff"
            bgcolor="#f26828"
            @click.native="getExcel()"
            :loading="exportLoading"
            >{{ exportLoading ? '正在导出中...' : '导出' }}</button-a
          >
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Get, Download } from '@/js/http.js'
import { Filter, dateConvert, translateWidth } from '@/js/tool.js'

export default {
  name: 'EmployeeContract',
  components: {},
  props: {},
  data () {
    return {
      input: '', // 员工搜索输入
      month: '', // 月份选择
      contractType: [true, true, true], // 合同类型
      qianyueType: [true, true], // 签约类型
      contractStatus: [true, true], // 合同状态（0: 生效中, 1: 已到期）
      contractStartDateRange: [], // 合同开始日期范围
      contractEndDateRange: [], // 合同结束日期范围
      options: [
        // 组织搜索框
      ],
      selectedValue: '', // 选择的组织id
      selectedValue2: '', // 选择的组织id 导出框
      page: 1, // 当前页码
      size: 10, // 每页条数
      total: 0, // 总条数
      tableData: [], // 表格数据
      loading: false, // 数据加载状态
      mask: false, // 遮罩
      switchGroup11: {
        劳动合同: true,
        实习协议: true,
        返聘协议: true
      },
      switchGroup12: {
        新签: true,
        续签: true
      },
      export_data: [
        { key: '员工姓名', label: '员工姓名', disabled: true },
        { key: '所属企业', label: '所属企业', disabled: true },
        { key: '证件类型', label: '证件类型' },
        { key: '证件号码', label: '证件号码', disabled: true },
        { key: '合同编号', label: '合同编号', disabled: true },
        { key: '合同类型', label: '合同类型', disabled: true },
        { key: '签约类型', label: '签约类型', disabled: true },
        { key: '合同开始时间', label: '合同开始时间' },
        { key: '合同结束时间', label: '合同结束时间' },
        { key: '合同甲方', label: '合同甲方' },
        { key: '合同乙方', label: '合同乙方' },
        { key: '合同性质', label: '合同性质' },
        { key: '用工单位', label: '用工单位' },
        { key: '合同期限', label: '合同期限' },
        { key: '期限类型', label: '期限类型' },
        { key: '试用期限', label: '试用期限' },
        { key: '工作岗位', label: '工作岗位' },
        { key: '工作地点', label: '工作地点' },
        { key: '工作期限', label: '工作期限' },
        { key: '试用工资', label: '试用工资' },
        { key: '转正工资', label: '转正工资' },
        { key: '发薪日期', label: '发薪日期' }
      ],
      export_value: [
        '员工姓名',
        '所属企业',
        '证件号码',
        '合同编号',
        '合同类型',
        '签约类型'
      ],
      exportLoading: false, // 导出加载状态
      disabled: '', // 禁止修改的开关
      clickTimer: null, // 单击定时器
      isDragging: false, // 是否正在拖动
      isDoubleClick: false // 是否双击
    }
  },
  watch: {},
  computed: {
    // 查询表格跳过的条数
    SkipCount () {
      return (this.page - 1) * this.size
    }
  },
  methods: {
    // 获取组织数据
    getOptions () {
      Get('api/v1/customers/selectors').then(({ data }) => {
        this.options = data
      })
    },

    // 获取表格数据
    getData () {
      this.loading = true
      let contractStr = []
      if (this.contractType[0]) contractStr.push('1') // 劳动合同
      if (this.contractType[1]) contractStr.push('2') // 实习协议
      if (this.contractType[2]) contractStr.push('4') // 返聘协议
      contractStr = contractStr.join(',')
      let QianYue = null
      if (this.qianyueType[0] && this.qianyueType[1]) {
        QianYue = '1,2' // 两种都选，传递"1,2"
      } else if (this.qianyueType[0]) {
        QianYue = 1 // 新签
      } else if (this.qianyueType[1]) {
        QianYue = 2 // 续签
      }

      // 处理日期范围
      let contractStartDateRange = this.contractStartDateRange || [null, null]
      let contractEndDateRange = this.contractEndDateRange || [null, null]
      
      // 处理合同状态
      let contractStatusStr = []
      if (this.contractStatus[0]) contractStatusStr.push('2') // 生效中
      if (this.contractStatus[1]) contractStatusStr.push('4') // 已到期
      contractStatusStr = contractStatusStr.join(',')
      
      Get('api/v1/employee-contracts', {
        // customerId: this.selectedValue || "", // 客户ID
        Keyword: this.input, // 员工姓名/证件号码
        ContractType: contractStr, // 合同类型
        SignType: QianYue, //签约类型（1-新签、2-续签）
        ContractStatus: contractStatusStr, // 合同状态（2-生效中、4-已到期）
        ContractStartDateBegin: contractStartDateRange[0], // 合同开始日期起始
        ContractStartDateEnd: contractStartDateRange[1], // 合同开始日期结束
        ContractEndDateBegin: contractEndDateRange[0], // 合同结束日期起始
        ContractEndDateEnd: contractEndDateRange[1], // 合同结束日期结束
        // ContractCode: STATUS, // 合同编号
        MaxResultCount: this.size, // 每页条数
        SkipCount: this.SkipCount // 跳过条数
      })
        .then(res => {
          this.total = res.data.totalCount
          this.tableData = res.data.items
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    //获得合同状态
    getStatus (data) {
      let time = new Date()
      let status = data.status
      let startdate = new Date(data.beginTime)
      let enddate = new Date(data.endTime)
      if (status == 0 && enddate != null) {
        return '已终止'
      } else if (status == 1 && startdate > time) {
        return '待生效'
      } else if (status == 1 && startdate < time && time < enddate) {
        return '生效中'
      } else if (status == 1 && time > enddate) {
        return '已到期'
      } else {
        return ''
      }
    },
    // 点击查询按钮
    query () {
      this.page = 1
      this.getData()
    },
    // 重置
    reset () {
      this.selectedValue = ''
      this.input = ''
      this.contractStartDateRange = [] // 重置合同开始日期范围
      this.contractEndDateRange = [] // 重置合同结束日期范围
      this.contractType = [true, true, true] // 重置合同类型为都选中
      this.contractStatus = [true, true] // 重置合同状态为都选中
      this.qianyueType = [true, true] // 重置签约类型为都选中
      this.page = 1 // 重置页码
      this.getData() // 查询数据
    },

    // 点击筛选标签，刷新dataName对象 dataName: String，对象名; key: Number/String
    change (dataName, key) {
      let ischanged = Filter.call(this, dataName, key)
      if (ischanged) {
        this.page = 1
        this.getData()
      }
    },
    // 每页条数选择
    handleSizeChange (v) {
      this.size = v
      this.getData()
    },
    // 页码选择
    handleCurrentChange (v) {
      this.page = v
      this.getData()
    },
    // 日期格式转换
    date (dateStr) {
      return dateConvert(dateStr)
    },

    // 显示对话框
    dialog () {
      // 检查是否全选状态
      let isAllContractType = this.contractType[0] && this.contractType[1] && this.contractType[2]
      let isAllContractStatus = this.contractStatus[0] && this.contractStatus[1]
      let isAllQianYueType = this.qianyueType[0] && this.qianyueType[1]
      let isAllSelected = isAllContractType && isAllContractStatus && isAllQianYueType
      
      // 当所有筛选条件都全选时，需要输入其他查询条件
      if (isAllSelected && !this.input && !this.contractStartDateRange[0] && !this.contractStartDateRange[1] && !this.contractEndDateRange[0] && !this.contractEndDateRange[1]) {
        this.$message.warning('请至少输入一个查询条件或选择一个筛选条件');
        return;
      }
      
      // 验证至少选择一个合同类型、合同状态或签约类型
      let hasContractType = this.contractType[0] || this.contractType[1] || this.contractType[2]
      let hasContractStatus = this.contractStatus[0] || this.contractStatus[1]
      let hasQianYueType = this.qianyueType[0] || this.qianyueType[1]
      
      if (!this.input && !this.contractStartDateRange[0] && !this.contractStartDateRange[1] && !this.contractEndDateRange[0] && !this.contractEndDateRange[1] && !hasContractType && !hasContractStatus && !hasQianYueType) {
        this.$message.warning('请至少输入一个查询条件或选择一个筛选条件');
        return;
      }
      
      this.mask = !this.mask
    },

    // 开关组1限制，至少打开一个
    changeSwitchGroup11 () {
      let choosen = []
      let changeSwitchGroup11 = this.switchGroup11
      for (let key in changeSwitchGroup11) {
        if (changeSwitchGroup11[key]) choosen.push(key)
      }
      if (choosen.length === 1) {
        this.disabled = choosen[0]
      } else {
        this.disabled = ''
      }
    },
    // 开关组1限制，至少打开一个
    changeSwitchGroup12 () {
      let choosen = []
      let changeSwitchGroup12 = this.switchGroup12
      for (let key in changeSwitchGroup12) {
        if (changeSwitchGroup12[key]) choosen.push(key)
      }
      if (choosen.length === 1) {
        this.disabled = choosen[0]
      } else {
        this.disabled = ''
      }
    },

    // 导出excel
    getExcel () {
      // 检查是否全选状态
      let isAllContractType = this.contractType[0] && this.contractType[1] && this.contractType[2]
      let isAllContractStatus = this.contractStatus[0] && this.contractStatus[1]
      let isAllQianYueType = this.qianyueType[0] && this.qianyueType[1]
      let isAllSelected = isAllContractType && isAllContractStatus && isAllQianYueType
      
      // 当所有筛选条件都全选时，需要输入其他查询条件
      if (isAllSelected && !this.input && !this.contractStartDateRange[0] && !this.contractStartDateRange[1] && !this.contractEndDateRange[0] && !this.contractEndDateRange[1]) {
        this.$message.warning('请至少输入一个查询条件或选择一个筛选条件');
        return;
      }
      
      // 验证至少选择一个合同类型、合同状态或签约类型
      let hasContractType = this.contractType[0] || this.contractType[1] || this.contractType[2]
      let hasContractStatus = this.contractStatus[0] || this.contractStatus[1]
      let hasQianYueType = this.qianyueType[0] || this.qianyueType[1]
      
      if (!this.input && !this.contractStartDateRange[0] && !this.contractStartDateRange[1] && !this.contractEndDateRange[0] && !this.contractEndDateRange[1] && !hasContractType && !hasContractStatus && !hasQianYueType) {
        this.$message.warning('请至少输入一个查询条件或选择一个筛选条件');
        return;
      }
      
      // 合同类型处理 - 与分页接口一致
      let contractType = []
      if (this.contractType[0]) contractType.push('1') // 劳动合同
      if (this.contractType[1]) contractType.push('2') // 实习协议
      if (this.contractType[2]) contractType.push('4') // 返聘协议
      contractType = contractType.join(',')

      // 签约类型处理 - 与分页接口一致
      let sings = null
      if (this.qianyueType[0] && this.qianyueType[1]) {
        sings = '1,2' // 两种都选，传递"1,2"
      } else if (this.qianyueType[0]) {
        sings = 1 // 新签
      } else if (this.qianyueType[1]) {
        sings = 2 // 续签
      }

      // 合同状态处理 - 与分页接口一致
      let contractStatusStr = []
      if (this.contractStatus[0]) contractStatusStr.push('2') // 生效中
      if (this.contractStatus[1]) contractStatusStr.push('4') // 已到期
      contractStatusStr = contractStatusStr.join(',')

      // 获取当前日期
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const dateStr = `${year}${month}${day}`;
      
      // 获取客户全称
      const customerName = localStorage.getItem('tenant_name') || localStorage.getItem('companyName') || '客户';
      
      // 设置导出加载状态
      this.exportLoading = true;
      
      Download(
        'api/v1/employee-contracts/excel',
        {
          // customerId: this.selectedValue2.join(",") || "", // 客户ID
          Keyword: this.input, // 员工姓名/证件号码
          ContractType: contractType, // 合同类型
          SignType: sings, //签约类型（1-新签、2-续签）
          ContractStatus: contractStatusStr, // 合同状态（2-生效中、4-已到期）
          ContractStartDateBegin: this.contractStartDateRange[0], // 合同开始日期起始
          ContractStartDateEnd: this.contractStartDateRange[1], // 合同开始日期结束
          ContractEndDateBegin: this.contractEndDateRange[0], // 合同结束日期起始
          ContractEndDateEnd: this.contractEndDateRange[1], // 合同结束日期结束
          ExportFields: this.export_value // 导出字段，直接传递数组
        },
        `${customerName}-员工合同-${dateStr}.xlsx`
      )
      .then(() => {
        // 导出成功
        this.exportLoading = false;
      })
      .catch(err => {
        // 导出失败
        this.exportLoading = false;
        this.$message.error('导出失败，请稍后重试');
        console.error('导出失败:', err);
      });
      this.mask = false
    },
    // 处理行点击（支持双击取消跳转、拖动选中不跳转）
    handleRowClick (item) {
      if (this.isDragging || this.isDoubleClick) {
        this.isDoubleClick = false;
        return;
      }
      if (this.clickTimer) {
        clearTimeout(this.clickTimer);
      }
      this.clickTimer = setTimeout(() => {
        this.$router.push({
          name: 'EmployeeContractItem',
          params: { id: item.pkId }
        });
        this.clickTimer = null;
      }, 300);
    },
    // 处理双击
    handleRowDblclick (item) {
      if (this.clickTimer) {
        clearTimeout(this.clickTimer);
        this.clickTimer = null;
      }
      this.isDoubleClick = true;
      this.copyRowData(item);
    },
    // 处理鼠标按下
    handleRowMousedown () {
      this.isDragging = false;
    },
    // 处理鼠标移动
    handleRowMousemove () {
      this.isDragging = true;
    },
    // 处理鼠标释放
    handleRowMouseup () {
      setTimeout(() => {
        this.isDragging = false;
      }, 100);
    },
    // 复制行数据文本
    copyRowData (item) {
      const rowText = `所属企业: ${item.customerName || ''}\n员工姓名: ${item.employeeName || ''}\n证件号码: ${item.idCard || ''}\n手机号码: ${item.phone || ''}\n合同编号: ${item.contractCode || ''}\n合同类型: ${item.contractType || ''}\n签约类型: ${item.signType || ''}\n合同开始时间: ${this.date(item.beginTime)}\n合同结束时间: ${this.date(item.endTime)}\n状态: ${this.getStatus(item)}`;
      
      navigator.clipboard.writeText(rowText).then(() => {
        this.$message.success('已复制整行数据');
      }).catch(() => {
        const textarea = document.createElement('textarea');
        textarea.value = rowText;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
        this.$message.success('已复制整行数据');
      });
    },
    // 查看（保留原方法，用于操作列的查看按钮）
    view (item) {
      this.$router.push({
        name: 'EmployeeContractItem',
        params: { id: item.pkId }
      })
    },
    // 穿梭框渲染
    renderFunc (h, option) {
      return h('span', option.label);
    },
    translateWidth (num) {
      return translateWidth(num)
    },
    // 绑定窗口缩放事件
    ifResize () {
      window.addEventListener('resize', this.resize)
    },
    resize () {
      this.getData()
    }
  },
  created () {},
  mounted () {
    this.getOptions()
    this.getData()
  },
  activated () {
    this.ifResize()
  },
  deactivated () {
    // 解除事件
    window.removeEventListener('resize', this.resize)
  },
  beforeDestroy () {}
}
</script>

<style lang="scss" scoped>
// 布局样式
.wrapper {
  padding: 180px 32px 24px;
  > div {
    margin-bottom: 32px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .filter {
  padding: 24px 48px;
  position: fixed;
  top: 70px;
  left: 11.6vw;
  right: 0;
  z-index: 100;
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  max-width: calc(100% - 11.6vw);
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  
  .filter-row {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;
    margin-bottom: 20px;
    
    &:last-child {
      margin-bottom: 0;
    }
    
    .date-label {
      font-size: 14px;
      color: #000;
      white-space: nowrap;
    }
    
    .date-group {
      display: flex;
      align-items: center;
      gap: 8px;
      flex: 1;
      min-width: 100%;
      @media (min-width: 1200px) {
        flex: none;
        min-width: auto;
      }
    }
    
    .custom-es {
      min-width: 200px;
      width: 250px;
      flex: 1;
      @media (max-width: 1199px) {
        min-width: 100%;
      }
    }
    
    .button-group {
      margin-left: auto;
      display: flex;
      gap: 12px;
      flex: 1;
      justify-content: flex-end;
      @media (max-width: 1199px) {
        min-width: 100%;
        margin-left: 0;
        justify-content: flex-start;
      }
      @media (min-width: 1200px) {
        flex: none;
        margin-left: auto;
        justify-content: flex-end;
      }
    }
    
    .filter-group {
      display: flex;
      align-items: center;
      gap: 8px;
      flex: 1;
      min-width: 100%;
      margin-bottom: 12px;
      
      &:last-child {
        margin-bottom: 0;
      }
      
      @media (min-width: 1200px) {
        flex: none;
        margin-bottom: 0;
        min-width: auto;
      }
      
      .font_14_black {
        margin: 0;
        white-space: nowrap;
      }
      
      .filter-tags {
        display: flex;
        gap: 8px;
        flex-wrap: wrap;
      }
    }
  }
}

  .sum-group {
    display: flex;
    padding: 24px 48px 24px;
    align-items: center;
    .sum {
      width: 240px;
      &:last-of-type {
        flex: 1;
      }
    }
  }
  .result {
    padding: 48px;
  }
}

// 查看按钮
.view {
  margin-right: 18px;
}

.wrapper {
  .export-title {
    margin-bottom: 32px;
  }
  .export-item {
    margin-bottom: 20px;
  }
}

.switch {
  flex-direction: column;
  .switch-group {
    flex: 1;
    flex-direction: row;
    align-items: center;
    // justify-content: space-between;
    padding-left: 10px;
    margin-right: 0;
    margin-bottom: 20px;
    .switch-title {
      white-space: nowrap;
      margin-bottom: 0;
      font-weight: bold;
      color: #000;
    }
    .switch-item {
      margin-left: 30px;
      margin-bottom: 0;
      min-width: 108px;
    }
  }
}
.transfer {
  display: flex;
  justify-content: center;
}
</style>
